import React from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { NepOrderContext } from '~/tenants/nep/model/NepOrder';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import { TenantPerformableConfiguration } from '~/tenants/common/performable';

export default function NepVirtualStagingForm(_props: TenantPerformableFormProps<NepOrderContext>) {
  return (
    <TenantPerformableConfiguration>
      <FormHorizontal name="photos" label="Photos">
        <ZodFieldInput name="photos" type="number" />
      </FormHorizontal>
    </TenantPerformableConfiguration>
  );
}
